// extracted by mini-css-extract-plugin
export default {"errorHeading":"style_errorHeading__J+WVk","errorContainer":"style_errorContainer__XsDJH"};